import type { EntityReference } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getOrganisationsRefData(): Promise<EntityReference[]> {
  return requestApiJsonOrThrow<EntityReference[]>('admin/reference-data/organisations')
}

export const organisationsRefDataQuery = {
  queryKey: ['organisations-ref-data'],
  queryFn: () => getOrganisationsRefData(),
}
